module.exports = require("./fr-LU.js");